import { useContext, useEffect, useState } from "react";
import DashboardService from "../services/api";
import { AssessmentContainer } from "../components/Container/AssessmentContainer";
import NoAssessments from "../components/Container/NoAssessmentContainer";
import { appContext } from "../Context/AppContext";
export const Survey = () => {
 const [data,setData] = useState([]);
 const { department, location ,fromDate ,toDate, monthValue} = useContext(appContext);
const fetchData = async()=>{
  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;
  DashboardService.getAssessmentsData(access_code,department, location,fromDate,toDate).then((res=>
    setData(res.data.typeCount)
  )).catch((e)=>{
    console.log(e);
  })
}
 useEffect(()=>{
  fetchData();
 },[department,location,fromDate])
  return (
    <div style={{ padding:"20px"}}>
     {data.length>0? <div className="assessment-container" style={{marginTop:"25px"}}>   
      {data.map((el: any, index: number) => (
            <div key={index}>
                <AssessmentContainer monthValue={monthValue} {...el} />
            </div>
        ))}
      </div>:<NoAssessments/>}
    </div>
  )
}
